<!--<perfect-scrollbar #perfectScroll [style.max-height]="'630px'" [style.padding-right]="'10px'">-->
<div class="messages-container d-flex h-100">
  <perfect-scrollbar #perfectScroll [style.padding-right]="'10px'">
    <div *ngFor="let log of ticketLogs"
         [ngClass]="{'left': !log.my, 'right': log.my}"
         class="message-wrapper">
      <div class="header-info">
        <div class="agent">
          <span *ngIf="log.my; else isOther">
            <font-awesome [icon]="'fa-light fa-user'" class="mr-4px"></font-awesome>
<!--            {{ userInfo | displayName }}-->
          </span>
          <ng-template #isOther>
            <span>
              <ng-container [ngSwitch]="log.channel">
                <font-awesome *ngSwitchCase="ticketLogChannel.Email" [icon]="'fa-light fa-envelope'"
                              class="mr-4px"></font-awesome>
                <font-awesome *ngSwitchCase="ticketLogChannel.Web" [icon]="'fa-light fa-clock-rotate-left'"
                              class="mr-4px"></font-awesome>
                <font-awesome *ngSwitchCase="ticketLogChannel.GCIC" [icon]="'fa-light fa-hammer'"
                              class="mr-4px"></font-awesome>
                <font-awesome *ngSwitchDefault [icon]="'fa-light fa-comment-lines'" class="mr-4px"></font-awesome>
              </ng-container>
              {{ log.name }}
            </span>
          </ng-template>
        </div>
        <div class="h-date">{{ log.createdAt | date: 'M/d/yyyy hh:mm a' | lowercase }}</div>
      </div>
      <div class="message-area">
        <span [innerHTML]="log.log"></span>
      </div>
    </div>
  </perfect-scrollbar>
  <ng-container *ngIf="loading">
    <div class="d-flex justify-content-center align-items-center" style="height: 5vh;">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </ng-container>
</div>


